import * as C from 'actions/constants';

export const blankState = {
  list: [],
  company: JSON.parse(localStorage.getItem('company')),
  meta: {},
  loading: false,
};

const CompaniesReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_COMPANIES: {
      return { ...state, loading: true };
    }
    case C.LOAD_COMPANIES_SUCCESS: {
      const { data, meta } = action;
      return {
        ...state,
        meta,
        loading: false,
        list: data,
      };
    }
    case C.LOAD_COMPANIES_ERROR: {
      return { ...state, loading: false };
    }
    case C.SET_COMPANY: {
      const { data } = action;
      return { ...state, company: data };
    }
    default:
      return state;
  }
};

export default CompaniesReducer;
